import { ENV_VALUES } from "../../constants/Enums";
import { linkedinRoutes } from "../../constants/Routes";
const dotenv = require("dotenv");

if (process.env.NODE_ENV === ENV_VALUES.development) {
	dotenv.config();
}

export const getLinkedInAccessTokenProxy = async (code) => {
	try {
		const currentUrl = window.location.origin + window.location.pathname;
		var body = {
			grant_type: "authorization_code",
			code: code,
			client_secret: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET,
			client_id: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
			redirect_uri: `${process.env.REACT_APP_LINKEDIN_BOUNCE_URL}?redirect_to=${currentUrl}`,
		};
		var formBody = [];
		for (var property in body) {
			var encodedKey = encodeURIComponent(property);
			var encodedValue = encodeURIComponent(body[property]);
			formBody.push(encodedKey + "=" + encodedValue);
		}
		formBody = formBody.join("&");
		let res = await fetch(process.env.REACT_APP_LINKEDIN_PROXY_ROUTE, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				url: "https://www.linkedin.com/oauth/v2/accessToken",
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: formBody,
			}),
		});
		let resJson = await res.json();
		return resJson.access_token;
	} catch (err) {
		console.log(err);
		return null;
	}
};

export const getLinkedInAccessToken = async (code) => {
	try {
		const response = await fetch(linkedinRoutes.linkedInAccessToken, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				code,
				redirect: `${process.env.REACT_APP_LINKEDIN_BOUNCE_URL}?redirect_to=${
					window.location.href.toString().split("?")[0]
				}`,
			}),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.statusText}`);
		}

		const result = await response.json();
		return result.access_token;
	} catch (error) {
		console.log(error);
		return "";
	}
};

export const getLinkedInUserIdProxy = async (token) => {
	try {
		let res = await fetch(process.env.REACT_APP_LINKEDIN_PROXY_ROUTE, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				url: "https://api.linkedin.com/v2/me",
				method: "GET",
				headers: {
					Accept: "application/json",
					Authorization: "Bearer " + token,
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		});
		let resJson = await res.json();
		return resJson.id;
	} catch (err) {
		console.log(err);
		return null;
	}
};

export const postLinkedinArticleProxy = async (
	token,
	userId,
	articleUrl,
	postTitle
) => {
	try {
		var bearer = "Bearer " + token;
		var author = "urn:li:person:" + userId;
		var body = {
			author: author,
			lifecycleState: "PUBLISHED",
			specificContent: {
				"com.linkedin.ugc.ShareContent": {
					shareCommentary: {
						text: postTitle,
					},
					shareMediaCategory: "ARTICLE",
					media: [
						{
							status: "READY",
							originalUrl: articleUrl,
						},
					],
				},
			},
			visibility: {
				"com.linkedin.ugc.MemberNetworkVisibility": "PUBLIC",
			},
		};
		let res = await fetch(process.env.REACT_APP_LINKEDIN_PROXY_ROUTE, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				url: "https://api.linkedin.com/v2/ugcPosts",
				method: "POST",
				headers: {
					Accept: "application/json",
					Authorization: bearer,
					"X-Restli-Protocol-Version": "2.0.0",
				},
				body: JSON.stringify(body),
			}),
		});
		let resJson = await res.json();
		return resJson;
	} catch (err) {
		console.log(err);
		return null;
	}
};

export const postLinkedinArticle = async (
	token,
	userId,
	articleUrl,
	credentialTitle,
	postTitle,
	credential_no
) => {
	try {
		var bearer = "Bearer " + token;
		var author = "urn:li:person:" + userId;

		let res = await fetch(linkedinRoutes.sharePostLinkedin, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				author: author,
				credentialTitle: credentialTitle,
				postTitle: postTitle,
				token: bearer,
				articleUrl: articleUrl,
				credential_no: credential_no,
			}),
		});

		let resJson = await res.json();
		return resJson;
	} catch (err) {
		console.log(err);
		return null;
	}
};
